export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    start: [
        { required: true, message: 'Пожалуйста, введите начало промо-акции ', trigger: 'change' },
    ],
    end: [
        { required: true, message: 'Пожалуйста, введите конец промо-акции ', trigger: 'change' },
    ],
};
